import { render } from "./IndexService.vue?vue&type=template&id=3fa693a0"
import script from "./IndexService.vue?vue&type=script&lang=js"
export * from "./IndexService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__